import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import BookingInfoCard from "@/components/booking/bookingInfoCard";
import InfoCircleIconSvg from "@/components/common/icons/infoCircleIconSvg";
import PageContainer from "@/components/common/pageContainer/pageContainer";
import PageHeader from "@/components/common/pageHeader/pageHeader";
import { GREY, PRIMARY } from "@/config/mui/colorPalette";
import { formatPhoneNumber } from "@/utils/formatPhoneNumber";

type Props = {
  medspaName: string;
  medspaPhone: string;
  goBackOnClick: () => void;
};

export default function BookingPhoneConflict({
  goBackOnClick,
  medspaName,
  medspaPhone,
}: Props) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: GREY[5],
        height: "100vh",
        width: "100vw",
        zIndex: 9999,
      }}
    >
      <PageContainer>
        <PageHeader
          title={
            <Stack
              sx={{
                direction: "row",
                mx: "auto",
                alignItems: "center",
              }}
            >
              <Image
                src="/assets/moxie-logo.svg"
                width={128}
                height={32}
                alt="Moxie logo"
              />
            </Stack>
          }
          goBackStrategy="onClick"
          goBackOnClick={goBackOnClick}
        />
        <BookingInfoCard>
          <Stack
            spacing={1}
            sx={{
              alignItems: "center",
            }}
          >
            <InfoCircleIconSvg />
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
              }}
            >
              Ooops, phone number conflict!
            </Typography>
            <Typography
              sx={{
                color: "secondary.main",
                textAlign: "center",
              }}
            >
              It seems that this number is used by more than one client at{" "}
              <strong>{medspaName}</strong>. Please reach out to the medspa
              directly to finalize the appointment.
            </Typography>
            {medspaPhone && (
              <Typography
                sx={{
                  textAlign: "center",
                }}
              >
                Call Med Spa:{" "}
                <a
                  style={{ color: PRIMARY, textDecoration: "none" }}
                  href={`tel:${medspaPhone}`}
                >
                  {formatPhoneNumber(medspaPhone)}
                </a>
              </Typography>
            )}
          </Stack>
        </BookingInfoCard>
      </PageContainer>
    </Box>
  );
}
